<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.DASHBOARD.CAMPAIGNS')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t('$vuetify.DASHBOARD.CAMPAIGN_DESCRIPTION'),
          disabled: true
        }
      ]"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-3">
          <v-toolbar class="elevation-0 col">
            <v-spacer v-if="isGlobalAdmin"></v-spacer>
            <v-btn
              color="white"
              small
              @click="
                editCampaign(null, false)
                void 0
              "
            >
              <v-icon class="success--text">mdi-plus</v-icon>
              {{ $vuetify.lang.t('$vuetify.CREATE_NEW_CAMPAIGN') }}
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-data-table
              :items="campaigns"
              :headers="headers"
              hide-default-footer
              :no-data-text="
                $vuetify.lang.t('$vuetify.DASHBOARD.NO_ACTIVE_CAMPAIGNS')
              "
              :items-per-page="-1"
              :loading="loading.state && loading.type === 'getCampaigns'"
            >
              <template
                v-for="(header, i) in headers"
                v-slot:[`header.${header.value}`]
              >
                <span v-if="header.i18n" :key="i">
                  {{ $vuetify.lang.t(`$vuetify.${header.i18n}`) }}
                </span>
                <span v-else-if="!header.i18n && header.text" :key="i">
                  {{ header.text }}
                </span>
              </template>

              <template v-slot:item.ValidFrom="props">
                <td>
                  {{
                    formatDate(
                      getDateInTimeZone(
                        props.item.ValidFrom,
                        props.item.TimeZone
                      )
                    )
                  }}
                </td>
              </template>
              <template v-slot:item.ValidTo="props">
                <td>
                  {{
                    formatDate(
                      getDateInTimeZone(props.item.ValidTo, props.item.TimeZone)
                    )
                  }}
                </td>
              </template>
              <template v-slot:item.actions="{ item }">
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        @click="editCampaign(item, false)"
                        v-on="on"
                      >
                        <v-icon small>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.EDIT') }}
                    </span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        class="mr-2"
                        color="blue darken-4"
                        @click="copyCampaign(item, true, false)"
                        v-on="on"
                      >
                        <v-icon small>
                          mdi-clipboard-file
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.COPY') }}
                    </span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        small
                        class="mr-2"
                        color="error"
                        @click="removeCampaign(item)"
                        v-on="on"
                      >
                        <v-icon small>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      {{ $vuetify.lang.t('$vuetify.DELETE') }}
                    </span>
                  </v-tooltip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-progress-circular
        v-if="loading.state"
        class="d-flex justify-center"
        indeterminate
        color="secondary"
        style="width: 100%"
      ></v-progress-circular>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'
import Campaign from '@/models/campaign'

export default {
  name: 'Campaigns',
  mixins: [formatDate],
  data() {
    return {
      headers: [
        {
          text: this.$vuetify.lang.t('$vuetify.REGION'),
          i18n: 'REGION',
          value: 'Region',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.NAME'),
          i18n: 'NAME',
          value: 'Name',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.DASHBOARD.CAMPAIGN_CODE'),
          i18n: 'DASHBOARD.CAMPAIGN_CODE',
          value: 'CampaignCode',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.DASHBOARD.REG_LIMIT'),
          i18n: 'DASHBOARD.REG_LIMIT',
          value: 'MaxNumberOfRegistrants',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.DASHBOARD.REGISTRANTS'),
          i18n: 'DASHBOARD.REGISTRANTS',
          value: 'ApprovedRegistrantsCount',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.VALID_FROM'),
          i18n: 'VALID_FROM',
          value: 'ValidFrom',
          guarded: false
        },
        {
          text: this.$vuetify.lang.t('$vuetify.VALID_TO'),
          i18n: 'VALID_TO',
          value: 'ValidTo',
          guarded: false
        },

        { text: '', value: 'actions' }
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('authentication', ['isGlobalAdmin']),
    ...mapGetters('campaigns', ['campaigns', 'currentCampaignId'])
  },
  created() {
    this.getCampaigns()
  },
  methods: {
    ...mapActions('campaigns', [
      'getCampaigns',
      'getRegistrants',
      'getCampaign'
    ]),
    removeCampaign(item) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.$store.dispatch('campaigns/removeCampaign', item)
        }
      })
    },
    copyCampaign(item, createNew, isTemplate) {
      if (item === null) {
        item = new Campaign().getObject()
        this.$store.commit('campaigns/setCampaign', new Campaign().getObject())
      }
      if (isTemplate) {
        this.$store.commit('campaigns/setIsTemplate', true)
        this.$store.commit('campaigns/setCampaignValue', {
          key: 'IsTemplate',
          value: true
        })
      }
      //   this.getCampaign(item.Id || item.ID)
      this.$store.commit('campaigns/setCurrentCampaignId', item.Id || item.ID)
      //   this.$store.commit('campaigns/setCampaign', new Campaign().getObject())
      if (createNew) {
        this.$store.commit('campaigns/setIsNew', createNew)
      } else {
        this.$store.commit('campaigns/setIsNew', false)
      }

      this.$router.push(`/campaign/${item.Id || item.ID}`)
    },
    editCampaign(item, createNew, isTemplate) {
      if (item === null) {
        item = new Campaign().getObject()
        this.$store.commit('campaigns/setCampaign', new Campaign().getObject())
      }

      if (isTemplate) {
        this.$store.commit('campaigns/setIsTemplate', isTemplate)
      }
      // this.$store.commit('campaigns/setCampaignValue', {
      //   key: 'IsTemplate',
      //   value: isTemplate
      // })
      //   this.getCampaign(item.Id || item.ID)
      this.$store.commit('campaigns/setCurrentCampaignId', item.Id || item.ID)
      //   this.$store.commit('campaigns/setCampaign', new Campaign().getObject())
      if (createNew) {
        this.$store.commit('campaigns/setIsNew', createNew)
      } else {
        this.$store.commit('campaigns/setIsNew', false)
      }

      this.$router.push(`/campaign/${item.Id || item.ID}`)
    }
  }
}
</script>
